var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loading"},[_c('svg-icon',{attrs:{"name":"loader"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }